module.exports = __webpack_public_path__ + "img/BG-Assessment.4dee7441.jpg";